export const FUNNEL_TYPOGRAPHY_SETTINGS = {
  color: true,
  bold: true,
  italic: true,
  fontSize: true,
};

export const VALUE_FONT_SIZES = [14, 16, 18, 20, 22, 24, 26];
export const LABEL_FONT_SIZES = [10, 11, 12, 13, 14, 15, 16];
export const BADGE_FONT_SIZES = [10, 11, 12, 13, 14, 15, 16];
